// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PalaceLayer extends BasePopUpLayer {

    @property(cc.Node)
    btnNode: cc.Node = null;

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.PalaceLayer, this.node, ()=> {
            this.recvAward();
        });

        this.recvAward();
        this.initLayer();
    }
    
    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.PalaceLayer);
    }

    recvAward() {
        let gameData = NormalGameManager._instance.getGameData();
        // 领取过
        if (gameData.bCompensateAward1) {
            return;
        }

        let bNoFirst = gameData.firstEnterLayer.includes(UIKind.UILayerTag.PalaceLayer);
        if (!bNoFirst) {
            return;
        }
        NormalGameManager._instance.openCompensateAwardLayer();
    }

    initLayer() {
        this.btnNode.children.forEach((n: cc.Node) => {
            if (!n.active) {
                return;
            }
            let touchArea = cc.find('touchArea', n);
            if (!touchArea) {
                return;
            }
            let line = n.getChildByName("line");
            line.active = false;
            let polygon = touchArea.getComponent(cc.PolygonCollider);
            touchArea.on("touchstart", (e: cc.Event.EventTouch) => {
                
                let touchPos = touchArea.convertToNodeSpaceAR(e.getLocation());
                touchPos.x -= polygon.offset.x;
                touchPos.y -= polygon.offset.y;

                if (cc.Intersection.pointInPolygon(touchPos, polygon.points)) {
                    if (line) {
                        line.active = true;
                    }
                    touchArea._touchListener.setSwallowTouches(true);
                } else {
                    touchArea._touchListener.setSwallowTouches(false);
                }
            }, this);
            touchArea.on("touchend", (e: cc.Event.EventTouch) => {
                let line = n.getChildByName("line");
                if (line && line.active) {
                    this.onBtnOpenPrefab(e, n.name);
                    line.active = false;
                }
            }, this);
            touchArea.on("touchcancel", (e: cc.Event.EventTouch) => {
                let line = n.getChildByName("line");
                if (line && line.active) {
                    line.active = false;
                }
            }, this);
        });
    }

    /**
     * 打开预制体
     * @param e
     * @param channel
     */
    async onBtnOpenPrefab(e, channel) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (O1HD.getServices().userSrv.getGameFail() == 1) {
            //游戏失败后，直接返回
            return;
        }
        
        switch (channel) {
            case 'btnXiangNianDian': {
                // O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
                let data = {
                    id: "27"
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                }
                utilsView.openEventLayer(
                    null
                    , data
                    , UI_Z_INDEX.DIALOG
                );
                break;
            }
            case 'btnRoyalCourtyard':{
                let data = {
                    id:"44"
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                }
                utilsView.openEventLayer(
                    null
                    , data
                    , UI_Z_INDEX.DIALOG
                );
                break;
            }
            default: {
                // O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
                let data = {
                    id: "23"
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                }
                utilsView.openEventLayer(
                    null
                    , data
                    , UI_Z_INDEX.DIALOG
                );
            }
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }
}
